import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import ReactPlayer from 'react-player'

import styles from "./DashboardViews.module.scss";

import {
    loadDocumentAction,
    loadSitesAction,
} from "store/actions/Actions";

const VideoView = (props) => {
    const { task, loadDocumentAction, document, loadSitesAction } = props;
    const [isActive, setActive] = useState(true);

    useEffect(() => {
        const vc = function (event) {
            if (window.document.hidden) {
                setActive(false);
            } else {
                setActive(true);
            }
        };
        window.document.addEventListener('visibilitychange', vc);
        return () => {
            window.document.removeEventListener('visibilitychange', vc);
        }
    });

    useEffect(() => {
        loadDocumentAction({ id: task.subtask_data.document });
    },  [task.id, loadDocumentAction]);

    return (
        <div className={styles.video}>
            {document && document.config && document.config.document && document.config.document.url && <ReactPlayer
                className={styles.video}
                height="auto"
                onProgress={(e) => isActive && loadSitesAction()}
                progressInterval={1000 * 60 * 5}
                controls
                width="100%"
                style={{ maxWidth: 960 }}
                playing
                url={document.config.document.url}
            />}

        </div>
    );
}

const mapStateToProps = state => ({
    document: state.DocumentReducer.document,
});

const mapDispatchToProps = {
    loadDocumentAction,
    loadSitesAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoView);
